// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__KThJE","loader_message":"Loader_loader_message__p9E+s"};